// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"6a25e378","497":"9371d700","785":"dd518f15"}[chunkId] + ".chunk.css";
};